/**
 * ADA patch: keyboard accessibility for Flickity slider page dots.
 *
 * Flickity renders its page dots as plain <li class="dot"> elements. This
 * patch preserves their list-item semantics and adds a real button inside
 * each dot. It also keeps controls in aria-hidden cells out of the tab order.
 *
 * Applies to all Flickity sliders in the theme, e.g. the testimonials
 * section ("We're proud to be part of hundreds of love stories") on the
 * home page.
 */
(function () {
  'use strict';

  var DOT_SELECTOR = '.flickity-page-dots .dot';
  var DOT_BUTTON_SELECTOR = '.ada-flickity-dot-button';
  var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';

  function patchDot(dot) {
    dot.removeAttribute('role');
    dot.removeAttribute('tabindex');

    var button = dot.querySelector(DOT_BUTTON_SELECTOR);
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = DOT_BUTTON_SELECTOR.slice(1);
      dot.appendChild(button);
    }

    var index = Array.prototype.indexOf.call(dot.parentNode.children, dot);
    button.setAttribute('aria-label', 'Show slide ' + (index + 1));
    dot.setAttribute('data-ada-dot', 'true');
  }

  function patchAll() {
    var dots = document.querySelectorAll(DOT_SELECTOR + ':not([data-ada-dot])');
    for (var i = 0; i < dots.length; i++) {
      patchDot(dots[i]);
    }
  }

  function selectDot(dot) {
    var slider = dot.closest('.flickity-enabled');
    if (!slider || typeof window.Flickity === 'undefined') return;

    var flkty = window.Flickity.data(slider);
    if (!flkty) return;

    var index = Array.prototype.indexOf.call(dot.parentNode.children, dot);
    if (index < 0) return;

    // Same as Flickity's own dot tap: pause autoplay briefly, then select.
    if (typeof flkty.uiChange === 'function') flkty.uiChange();
    flkty.select(index);
  }

  function patchHiddenCells() {
    var cells = document.querySelectorAll('.flickity-slider > [aria-hidden]');
    for (var i = 0; i < cells.length; i++) {
      var hidden = cells[i].getAttribute('aria-hidden') === 'true';
      var controls = cells[i].querySelectorAll(FOCUSABLE_SELECTOR);

      for (var j = 0; j < controls.length; j++) {
        var control = controls[j];
        if (hidden) {
          if (!control.hasAttribute('data-ada-flickity-tabindex')) {
            control.setAttribute(
              'data-ada-flickity-tabindex',
              control.hasAttribute('tabindex') ? control.getAttribute('tabindex') : ''
            );
          }
          control.setAttribute('tabindex', '-1');
        } else if (control.hasAttribute('data-ada-flickity-tabindex')) {
          var previous = control.getAttribute('data-ada-flickity-tabindex');
          if (previous === '') control.removeAttribute('tabindex');
          else control.setAttribute('tabindex', previous);
          control.removeAttribute('data-ada-flickity-tabindex');
        }
      }
    }
  }

  // Delegated so it also covers dots created after this script runs. Native
  // buttons already convert Enter and Space to click events.
  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || !target.matches || !target.matches(DOT_BUTTON_SELECTOR)) return;

    evt.preventDefault();
    evt.stopPropagation();
    selectDot(target.closest(DOT_SELECTOR));
  });

  // Flickity initializes from deferred scripts (after this file executes),
  // and dots are re-rendered on section reloads in the theme editor, so
  // watch the DOM instead of patching only once.
  var scheduled = false;
  function schedulePatch() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      patchAll();
      patchHiddenCells();
    });
  }

  function init() {
    patchAll();
    patchHiddenCells();
    new MutationObserver(schedulePatch).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
